/*
  <gaia-dropdown>
    <details>
      <summary>Heading</summary>
      <div>Content</div>
    </details>
  </gaia-dropdown>
*/

class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.content = this.querySelector('summary + *');

    if (this.content.getAttribute('tabindex') === null) this.content.setAttribute('tabindex', '0');

    this.details.addEventListener('focusout', this.clickOff.bind(this));
  }

  clickOff() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.details.removeAttribute('open');
    });
  }
}

customElements.define("gaia-dropdown", GaiaDropdown);
